

































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PlanItem extends Vue {
  @Prop() plan: any;
  @Prop() prescriptionForm: any;
  @Prop() isDisabled: boolean;
  @Prop({ default: false }) isEditKarte: boolean;
  @Prop({ default: 'select' }) mode!: 'select' | 'view';
  @Prop({ default: 'plan-flex-80' }) className?: string;
  @Prop() from?: string;

  private showMedicine: boolean = false;

  private get isSelectedPlan() {
    return (
      this.prescriptionForm.plans.filter(
        (item) => item.id === this.plan.id || item === this.plan.id,
      ).length > 0
    );
  }

  private get isShowRecommend() {
    return (
      (this.isEditKarte && this.plan.recommended) ||
      (!this.isEditKarte && this.mode === 'select') ||
      (this.plan.recommended && this.mode === 'view') ||
      (this.isEditKarte &&
        this.prescriptionForm.old_type === 'reserve_prescription')
    );
  }

  private get isModeViewFromChatFrameWithPlanRecommend() {
    return (
      (this.mode === 'view' &&
        this.from &&
        this.from === 'chat' &&
        this.plan.recommended) ||
      !this.from
    );
  }

  togglePlanDetail() {
    this.showMedicine = !this.showMedicine;
  }

  handleSelectPlan($event: any, plan) {
    const index = this.prescriptionForm.plans.findIndex(
      (item) => item.id === plan.id,
    );

    if (index !== -1) {
      // Remove plan
      this.prescriptionForm.plans = [
        ...this.prescriptionForm.plans.slice(0, index),
        ...this.prescriptionForm.plans.slice(index + 1),
      ];
    } else {
      this.prescriptionForm.plans = [
        ...this.prescriptionForm.plans,
        { id: plan.id, recommended: false },
      ];
    }
  }

  handleRecommendPlan($event: any, plan) {
    const index = this.prescriptionForm.plans.findIndex(
      (item) => item.id === plan.id,
    );

    if (index !== -1) {
      this.prescriptionForm.plans = [
        ...this.prescriptionForm.plans.slice(0, index),
        {
          ...this.prescriptionForm.plans[index],
          recommended: !this.prescriptionForm.plans[index].recommended,
        },
        ...this.prescriptionForm.plans.slice(index + 1),
      ];
    } else {
      this.prescriptionForm.plans = [
        ...this.prescriptionForm.plans,
        { id: plan.id, recommended: true },
      ];
    }
  }
}
